module.exports = __webpack_public_path__ + "img/all.c884f427.svg";